import { RequestOptionsAnyType } from '../types/request-options.type';

export const REQUEST_OPTIONS: RequestOptionsAnyType = {
  observe: 'body',
  reportProgress: false,
  options: undefined,
};
